export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBir4RAhgy1ThzKjHV4TjJTkI45ktKF4uc",
  authDomain: "eisenhower-pro-5bb76.firebaseapp.com",
  projectId: "eisenhower-pro-5bb76",
  storageBucket: "eisenhower-pro-5bb76.firebasestorage.app",
  messagingSenderId: "557254945754",
  appId: "1:557254945754:web:1de92a9a8a9f76ab21aee3"
};

export const STRIPE_LINKS = {
  checkout: "https://buy.stripe.com/test_aFabJ0fYM5Ns8wh5jL48000" // Replace with your actual Stripe Payment Link
};

// Logo oficial Eisenhower Pro (Base64 para redundância)
export const APP_LOGO = "logo.png"; // O navegador tentará carregar o arquivo primeiro

export const FREE_TIER_LIMIT = 30;
export const FREE_AI_LIMIT = 3;
export const FREE_ROUTINE_LIMIT = 2;

export const QUADRANT_LABELS = {
  DO: "Do First (Urgent & Important)",
  SCHEDULE: "Schedule (Important, Not Urgent)",
  DELEGATE: "Delegate (Urgent, Not Important)",
  ELIMINATE: "Eliminate (Neither)"
};

export const QUADRANT_COLORS = {
  DO: "bg-red-50 border-red-200 text-red-900",
  SCHEDULE: "bg-blue-50 border-blue-200 text-blue-900",
  DELEGATE: "bg-yellow-50 border-yellow-200 text-yellow-900",
  ELIMINATE: "bg-emerald-50 border-emerald-200 text-emerald-900"
};

export const XP_VALUES = {
  TASK_DO: 10,
  TASK_SCHEDULE: 20,
  TASK_DELEGATE: 5,
  TASK_ELIMINATE: 5,
  FOCUS_SESSION: 50
};

export const LEVELS = [
  { level: 1, title: 'Novice', xp: 0, unlock: 'Standard Features' },
  { level: 2, title: 'Apprentice', xp: 500, unlock: 'Unlock: Alpha Waves Sound' },
  { level: 3, title: 'Associate', xp: 1500, unlock: 'Unlock: Dark Mode' },
  { level: 4, title: 'Strategist', xp: 3000, unlock: 'Unlock: Heatmap Analytics' },
  { level: 5, title: 'Master', xp: 6000, unlock: 'Unlock: Space Station Sound' },
  { level: 6, title: 'Visionary', xp: 10000, unlock: 'Unlock: Midnight Theme' },
];

export const THEMES = [
  { id: 'light', label: 'Classic Light', minLevel: 1 },
  { id: 'dark', label: 'Dark Mode', minLevel: 3 },
  { id: 'midnight', label: 'Midnight Blue', minLevel: 6 },
];

export const SOUNDSCAPES = [
  { id: 'rain', label: 'Heavy Rain', icon: 'CloudRain', url: '/sounds/rain.mp3', minLevel: 1 },
  { id: 'forest', label: 'Forest Birds', icon: 'Trees', url: '/sounds/forest.mp3', minLevel: 1 },
  { id: 'cafe', label: 'Coffee Shop', icon: 'Coffee', url: '/sounds/cafe.mp3', minLevel: 1 },
  { id: 'white', label: 'White Noise', icon: 'Waves', url: '/sounds/white-noise.mp3', minLevel: 1 },
  { id: 'alpha', label: 'Alpha Waves', icon: 'Zap', url: '/sounds/alpha.mp3', minLevel: 2 }, 
  { id: 'space', label: 'Space Station', icon: 'Globe', url: '/sounds/space.mp3', minLevel: 5 }, 
];
